import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=ce42815e&scoped=true&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce42815e",
  null
  
)

export default component.exports